import templateUrl from "emun.on-demand/media/remote-upload-media-prompt.htm";
import controller from "emun.on-demand/media/remote-upload-media-prompt.controller";
import open from "webmodals/open";

let remoteUploadMediaPrompt = options => {
  let modalInstance = open({
    size: options.size || "sm",
    templateUrl: options.templateUrl || templateUrl,
    controller,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  });

  return modalInstance.result;
};

export default remoteUploadMediaPrompt;
